import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import SmartGrid, { ColumnConfig } from '../../components/smartGrid/SmartGrid';
import { useTriage } from '../../data/hooks/useTriage.hook';
import { Triage, triageConstants } from '../../data/types/triage.types';
import { Spinner } from '../../components/spinner/Spinner.component';
 
interface Entity extends Triage {}
const entityConstants = triageConstants
 
export const TriageBrowse = () => {
	const { data, isPending, isError, error } = useTriage();
	const navigate = useNavigate()
	const queryClient = useQueryClient();
 
	const columns: ColumnConfig[] = [
	  {
		key: 'nombre',
		header: 'Nombre',
		dataType: 'text',
		filterable: true,
		sortable: true,
		horizontalAlign: 'left',
		width: 40
	  },
	  {
		key: 'activo',
		header: 'Activo',
		dataType: 'boolean',
		filterable: true,
		filterBy: 'FORMATTED',
		horizontalAlign: 'left',
		width: 10,
		formatter: (value: boolean) => {
			// console.log('### value', value)
			return Boolean(value) ? 'Activo' : 'No'
		}
	  }
	];
 
	const rowActions = [
	  {
		label: '',
		action: (selected: Entity[]) => navigate(`${entityConstants.navigateToParent}/${selected[0].id}`),
		icon: '✏️'
	  },
	  {
		label: '',
		preset: 'delete',
		config: {
		  apiEndpoint: entityConstants.apiEndpoint,
		  entityName: entityConstants.entityLabel,
		},
		action: (selected: any) => {
		  // queryClient.invalidateQueries({queryKey: ['products']});
		  navigate(entityConstants.apiEndpoint);
		},
		icon: '🗑️'
	  }
  ];
 
  if (isPending) return <Spinner />
  
  return (
		<div style={{ margin: '0 150px' }}>
			{isError && <div style={{ color: 'red' }}>Error: {error?.message}</div>}
			{(!isPending && !isError) && <SmartGrid
				data={data || []}
				columns={columns}
				pageSize={10}
				rowActions={rowActions}
				defaultSort={{ key: 'nombre', direction: 'desc' }}
				toolbarComponents={[
				  {
					type: 'title',
					title: entityConstants.entityLabel
				  },
				  {
					type: 'command',
					label: 'Nuevo Triage',
					onClick: () => navigate(`${triageConstants.navigateToParent}/new`),
				  }
				]}
			/>}
		</div>
	);
 
}
